import { useState } from "react"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { useFetchRateCardsConfigsQuery } from "../../../../../redux/queries"
import Form from "../../../form"

interface RateCardsSelectorProps {
  integration: Integration
}

const RateCardsSelector = ({ integration }: RateCardsSelectorProps) => {
  const { app_settings, saveSetting } = useIntegrationSettingsForm(integration)

  const [selectedID, setSelectedRateCardsID] = useState<string>(
    String(app_settings?.settings?.rateCardsConfigId ?? "")
  )

  const { data: rateCards = [], isLoading } = useFetchRateCardsConfigsQuery(
    { brand_id: integration?.brand_id },
    { skip: !integration?.brand_id }
  )

  const selected = rateCards.find(rc => rc.id === selectedID) ?? null

  const setSelected = (rateCardsID: string) => {
    if (rateCardsID !== selectedID) {
      setSelectedRateCardsID(rateCardsID)
      saveSetting({ rateCardsConfigId: rateCardsID })
    }
  }

  return (
    <div className="flex items-center pl-9">
      <Form.InlineSelect
        isLoading={isLoading}
        data={rateCards}
        setSelected={setSelected}
        selected={selected}
        label="Choose a rate cards config"
      />
    </div>
  )
}

export default RateCardsSelector
